export default __webpack_public_path__ + "static/media/braided.11e99d96.jpg";